<template>
  <div class="redirect-card">
    <router-link :to="{ name: route }" :disabled="!active">
      <div class="card">
        <div class="card-body">
          <div class="title-container">
            <div class="d-flex justify-content-center align-items-center">
              <font-awesome-icon
                  v-for="icon in icons"
                  v-bind:key="icon"
                  :icon="icon"
                  class="title-icon"
              />
            </div>
            <span class="card-title tk-orpheuspro">{{ title }}</span>
          </div>
          <div class="description-container">
            <span v-html="content"></span>
            <span v-if="!active">&nbsp;(Inactive)</span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SelectCard',
  props: {
    icons: Array,
    active: Boolean,
    route: String,
    title: String,
    content: String
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/variables";

.redirect-card {
  a {
    text-decoration: none;
    color: unset;
    .card {
      width: 300px;
      height: 400px;
      box-shadow: 0 3px 6px #000000CC;
      border-radius: 10px;
      margin: 0;
      &:hover {
        border: 5px solid $home-card;
      }
      .card-body {
        color: $home-card;
        padding: 0;

        .title-container {
          height: 67%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .title-icon {
            font-size: 4.5rem;
            margin: 50px 5px;
          }
          .card-title {
            font-size: 24px;
            font-weight: bold;
          }
        }
        .description-container {
          height: 33%;
          padding: 10px;
          background-color: #F0F1F7;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            font-family: 'Source Sans Pro', sans-serif;
            font-size: 18px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
